import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { ReactComponent as AvatarImage } from './images/avatar.svg';
import styles from './UserInfo.module.scss';
import { remotePaths } from 'router/routes';

class UserInfo extends PureComponent {
  static defaultProps = {
    userName: 'хххххх хххххх хххххххххххх',
    inn: 'хххххххххххх',
  };

  render() {
    const { userName, avatar, inn, hasDebts } = this.props;
    return (
      <div className={styles.userInfo}>
        <a
          href={remotePaths.profile}
          title={'Профиль'}
          className={classnames(styles.photo, { [styles.whiteBorder]: !hasDebts })}
          style={avatar ? { backgroundImage: `url(${avatar})` } : {}}
        >
          {!avatar && <AvatarImage className={styles.defaultAvatar} title={'Профиль'} />}
        </a>
        <div className={styles.profile}>
          <a href={remotePaths.profile} className={styles.text}>
            {userName}
          </a>
          <span className={styles.inn}>ИНН {inn}</span>
        </div>
      </div>
    );
  }
}

UserInfo.propTypes = {
  userName: PropTypes.string,
  hasDebts: PropTypes.bool,
  avatar: PropTypes.string,
  inn: PropTypes.string,
};

export default UserInfo;
